import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
export var divider = function divider(item) {
  /** 分割线 */
  if (item.valueType === 'divider') {
    var _item$getFieldProps;

    return /*#__PURE__*/React.createElement(_Divider, _extends({}, (_item$getFieldProps = item.getFieldProps) === null || _item$getFieldProps === void 0 ? void 0 : _item$getFieldProps.call(item), {
      key: item.key
    }));
  }

  return true;
};